import styled, {css}from "styled-components"
import React, {Component} from "react"
import Select from "react-select"

export const Label = styled.label`
  color: #8C8C8C;
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  letter-spacing: 0;
  margin-bottom: ${props => props.marginBottom || '7.5px'};
`

const Base = css`
  color: #1C1C1C;
  font-size: 14px;
  line-height: 18px;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  width: 100%;
  background-clip: padding-box;
  
  &:focus {
    outline: none;
  }
`
const Input = styled.input`
  ${Base}
  padding-top: 12.5px;
  padding-bottom: 11.5px;
  padding-left: 11.5px;
  ${props => props.hideArrows && `
    ::-webkit-inner-spin-button{
        -webkit-appearance: none; 
        margin: 0; 
    }
    ::-webkit-outer-spin-button{
        -webkit-appearance: none; 
        margin: 0; 
    }
    -moz-appearance: textfield;
  `}
`

const selectorControlStyle = {
  fontSize: "14px",
  fontWeight: "400px",
  lineHeight: "18px",
  border: "none",
  boxShadow: 'none',
  marginTop: "5px",
}

const Selector = styled(Select)` 
  ${Base} 
  height: 44px;
`
export const InputContainer = styled.fieldset`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  flex-grow: 1;
  width: ${props => props.width || "auto"};
`

export class SettlementInput extends Component {

  render() {
    const {label, value, type, onChange, hideArrows, onKeyPress} = this.props
    return (
      <InputContainer>
        <Label>{label}</Label>
        <Input value={value} type={type || "text"} onChange={onChange} hideArrows={hideArrows} onKeyPress={onKeyPress}/>
      </InputContainer>
    )
  }

}

export class SettlementSelect extends Component {

  render() {
    const {label, value, onChange, options} = this.props
    return (
      <InputContainer width={"50%"}>
        <Label>{label}</Label>
        <Selector style={selectorControlStyle} clearable={false} backspaceRemoves={false} value={value} onChange={onChange} options={options}/>
      </InputContainer>
    )
  }

}
